// src/settings/SettingsPage.tsx
import { SecretsPanel } from './SecretsPanel'
import { AccountPanel } from './AccountPanel'
import { UgcSettingsPanel } from '../crm/ugc/UgcSettingsPanel'

export function SettingsPage() {
  return (
    <div style={{ padding: '2rem 2.5rem', maxWidth: '760px' }}>
      <h1 style={{
        fontSize: '1.5rem',
        fontWeight: 600,
        color: 'var(--fg)',
        margin: '0 0 2rem',
        letterSpacing: '-0.025em',
      }}>
        Réglages
      </h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        <SecretsPanel />
        <AccountPanel />
        <UgcSettingsPanel />
      </div>
    </div>
  )
}
